if (!customElements.get('novaging-bundle-offer')) {
  customElements.define('novaging-bundle-offer', class extends HTMLElement {
    static instanceCount = 0;

    connectedCallback() {
      this.scope = this.closest('.nv-purchase');
      if (!this.scope) return;
      const instanceName = `novaging-bundle-instance-${++this.constructor.instanceCount}`;
      for (const radio of this.querySelectorAll('.nv-bundle__radio')) {
        radio.name = instanceName;
        radio.id = `${instanceName}-${radio.value}`;
        radio.closest('label')?.setAttribute('for', radio.id);
      }
      if (this.closest('dialog, .quick-add-modal, quick-add-dialog')) this.id = instanceName;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('change', event => {
        if (!event.target.matches('.nv-bundle__radio')) return;
        const input = this.quantityInput();
        const value = Number(event.target.value);
        if (!input || !this.acceptsQuantity(input, value)) return;
        input.value = String(value);
        const selector = input.closest('quantity-selector-component');
        selector?.onQuantityChange?.();
        selector?.updateButtonStates?.();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        this.sync();
      }, options);
      const scheduleSync = event => {
        if (event?.target?.closest('novaging-bundle-offer') === this) return;
        queueMicrotask(() => { if (this.isConnected) this.sync(); });
      };
      for (const type of ['input', 'change', 'click', 'blur', 'quantity-selector:update']) {
        this.scope.addEventListener(type, scheduleSync, { ...options, capture: type === 'blur' });
      }
      this.observer = new MutationObserver(() => scheduleSync());
      this.observer.observe(this.scope, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['min', 'max', 'step', 'disabled', 'data-cart-quantity']
      });
      queueMicrotask(() => { if (this.isConnected) this.sync(); });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    quantityInput() {
      return this.scope?.querySelector('product-form-component form input[name="quantity"]');
    }

    acceptsQuantity(input, quantity) {
      if (input.disabled || !Number.isInteger(quantity)) return false;
      const min = Number(input.min || 1);
      const step = Number(input.step || 1);
      const inCart = Number(input.dataset.cartQuantity || 0);
      const max = input.max === '' ? Infinity : Math.max(min, Number(input.max) - inCart);
      return quantity >= min && quantity <= max && (quantity - min) % step === 0;
    }

    sync() {
      const input = this.quantityInput();
      const fieldset = this.querySelector('fieldset');
      if (!fieldset) return;
      const unavailable = !input || input.disabled;
      if (fieldset.disabled !== unavailable) fieldset.disabled = unavailable;
      if (!input) return;
      const current = Number(input.value);
      for (const radio of this.querySelectorAll('.nv-bundle__radio')) {
        const value = Number(radio.value);
        const disabled = !this.acceptsQuantity(input, value);
        if (radio.disabled !== disabled) radio.disabled = disabled;
        radio.checked = current === value;
      }
      this.toggleAttribute('data-ready', true);
    }
  });
}
